<template>
  <div id="layout-footer" class="group">
    <footer id="footer">
      <div id="footer-quad" class="group"></div>
      <div id="footer-sig" class="group">
        <div class="zone zone-footer">
          <article class="widget-footer widget-rccl-footer-widget widget">
            <!-- bottomBanner -->
            <section class="partner-bottomBanner" v-if="isTransparent">
              <img
                src="https://resource.rcclchina.com.cn/Home/new/new-bottom-v2.0.jpg"
                alt="皇家加勒比国际豪华游轮"
                title="皇家加勒比国际豪华游轮"
                :style="bottomImageStyle"
              />
            </section>
            <section v-else class="f-dn"></section>
            <div
              class="foot_content"
              :class="{ 'normal-foot-content': !isTransparent }"
            >
              <div class="foot_middle partner_foot_middle">
                <div class="container">
                  <div class="row">
                    <div
                      class="col-lg-2 col-md-2 col-sm-2"
                      v-for="item in navItems"
                      :key="item.id"
                    >
                      <h3>{{ item.title }}</h3>
                      <ul>
                        <li
                          v-for="subItem in filterShowInPc(item.navSubItems)"
                          :key="subItem.id"
                        >
                          <a :href="getFooterSubItemLink(subItem)" class="">{{
                            subItem.title
                          }}</a>
                        </li>
                      </ul>
                    </div>

                    <div class="col-lg-2 col-md-2 col-sm-2">
                      <h3 @click="goContact" style="cursor: pointer">
                        联系我们
                      </h3>
                      <ul>
                        <li
                          class="footer__txt phoneCall_info"
                          id="bottom_callcenter_phone"
                        >
                          <a>400-820-7195</a>
                        </li>
                        <li>
                          <a id="footer_online_service" @click="showOnlineService" style="cursor: pointer"
                            >在线客服</a
                          >
                        </li>
                        <li class="weixin__linkPic footer__txt footer-wxQrCode" @mouseenter="showTinyWechatQrCode=true" @mouseleave="showTinyWechatQrCode=false">
                          <a>企微客服</a>
                          <div class="weixinTiny__container" v-show="showTinyWechatQrCode">
                            <div class="arrow"></div>
                            <div class="service_code">
                              <img
                                  src="https://resource.rcclchina.com.cn/wechatMiniProgram/pc-footerBar_v1.0.png"
                                  alt=""
                              />
                              <p>添加企微客服<br/>领取专属福利</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <a href="http://weibo.com/rcclchina" target="_blank"
                            >官方微博</a
                          >
                        </li>
                        <li class="weixin__linkPic footer__txt footer-wxQrCode" @mouseenter="showWechatQrCode=true" @mouseleave="showWechatQrCode=false">
                          <a>官方微信</a>
                          <div class="weixinTiny__container" v-show="showWechatQrCode">
                            <div class="arrow"></div>
                            <div class="service_code">
                              <img
                                  src="https://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/weixin.jpg"
                                  alt=""
                              />
                              <p>官方服务号</p>
                            </div>
                          </div>

                        </li>

                        <li>
                          <a
                            href="https://www.rcclchina.com.cn/privilege/pcp/royalapp"
                            >下载皇家APP</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="foot_bottom partner_foot_bottom">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-3">
                      <a href="/"
                        ><img
                          class="logo_bottom"
                          src="https://resource.rcclchina.com.cn/logo/PC/logoFooterWhite.png"
                          alt="皇家加勒比国际豪华游轮"
                      /></a>
                    </div>
                    <div class="col-sm-9 col-lg-7 col-lg-offset-2">
                      <div class="right">
                        <a
                          href="/content/brand/passenger/repeat"
                          target="_blank"
                          >乘客票据合同及安全与保障政策</a
                        >
                        <span class="split">|</span>
                        <a
                          href="/content/brand/legalinfo/repeat"
                          target="_blank"
                          >用户协议</a
                        >
                        <span class="split">|</span>
                        <a
                          href="/Rccl.UserCenter/Privacy"
                          target="_blank"
                          >隐私政策</a
                        >
                        <span class="split">|</span>
                        <a
                          href="/content/brand/billofrights/repeat"
                          target="_blank"
                          >邮轮业乘客权利法案</a
                        ><span class="split"></span>
                        <img
                          class="imgRight"
                          src="https://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/commerce.png"
                          alt=""
                        />
                        <a
                          :href="`${imgUrl}/footer/WFSE营业执照.pdf`"
                          target="_blank"
                          >上海工商</a
                        >
                      </div>
                      <div class="right">
                        皇家加勒比游轮船务（中国）有限公司版权所有
                        <span class="split">|</span>
                        <img
                          class="imgRight"
                          src="https://www.rcclchina.com.cn/Themes/Rccl.NewTheme/image/navi/police.png"
                          alt=""
                        />
                        <a
                          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000123"
                          target="_blank"
                          >沪公网安备 31022102000123</a
                        >
                        <span class="split">|</span>
                        <a href="https://beian.miit.gov.cn/" target="_blank"
                          >沪ICP备09065404号-1</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {jumpOnlineService} from "@/utilities/common";
export default {
  name: "BaseFooter",
  beforeMount() {
    this.routeName = this.$router.currentRoute.name.toLowerCase();
  },
  data() {
    return {
      routeName: "",
      showWechatQrCode: false,
      showTinyWechatQrCode:false,
      imgUrl: process.env.VUE_APP_IMG_URL
    };
  },
  methods: {
    filterShowInPc(navItems) {
      return navItems.filter(function (item) {
        return item.showPc;
      });
    },
    getFooterSubItemLink(subItem) {
      if (!subItem || subItem.title !== "皇家行前订" || !subItem.link) {
        return subItem && subItem.link;
      }

      return subItem.link.replace(/([?&]hmpl=)[^&]*/, "$1bottombar");
    },
    goContact() {
      window.location = "https://www.rcclchina.com.cn/contactUs";
    },
    showOnlineService() {
      jumpOnlineService();
    }
  },
  computed: {
    navItems() {
      return this.$store.state.page.navItems;
    },

    isTransparent() {
      return (
        [
          "index",
          "partnerindex",
          "partnerregister",
          "partnerlogin",
          "partneractive",
        ].indexOf(this.routeName.toLowerCase()) >= 0
      );
    },
    bottomImageStyle() {
      const windowWidth = window.innerWidth;
      if (windowWidth > 1920) {
        return {
          left: "0",
          width: "100%",
        };
      } else if (windowWidth > 1200) {
        let width = (1920 - windowWidth) / 2;
        return {
          left: -width + "px",
          width: "1920px",
        };
      } else {
        let width = (1920 - 1200) / 2;
        return {
          left: -width + "px",
          width: "1920px",
        };
      }
    },
  },
  watch: {
    $route(to) {
      this.routeName = to.name.toLowerCase();
    },
  },
};
</script>

<style lang="less" scoped>
#layout-footer .foot_middle .container {
  .weixin__container {
    display: block;
  }
}
#layout-footer .foot_bottom .container {
  .split {
    margin: 0px 8px;
  }
  .imgRight {
    margin-right: 4px;
  }
}
.footer-wxQrCode{
  position: relative;
}
.weixinTiny__container{
  position: absolute;
  top: 27px;
  left: 0;
  width: 144px;
  //height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  z-index: 1111;
  -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  img{
    width: 100px;
    height: 100px;
    margin-top: 10px;
  }
  p{
    text-align: center;
    color: #000f57;
    margin-top: 10px;
  }
}
</style>
